import { api } from "./client";
import type { LinkOut, ProfileOut, ProfileUpdate, PublicProfileOut } from "./types";

export async function getMe() {
  return api.get<ProfileOut>("/me");
}

export async function updateMe(payload: ProfileUpdate) {
  return api.put<ProfileOut>("/me", payload as unknown as Record<string, unknown>);
}

export async function getMyLinks() {
  return api.get<LinkOut[]>("/me/links");
}

export async function replaceMyLinks(links: Omit<LinkOut, "id">[]) {
  return api.put<LinkOut[]>("/me/links", { links } as unknown as Record<string, unknown>);
}

export async function getPublicProfile(username: string) {
  return api.get<PublicProfileOut>(`/users/${encodeURIComponent(username)}`, { auth: false });
}
